import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "hideEmail",
	standalone: false
})
export class HideEmailPipe implements PipeTransform {
	transform(email: string): string {
		if (!email || typeof email !== "string") {
			return email;
		}

		const atIndex = email.indexOf("@");
		if (atIndex > 0) {
			const username = email.substring(0, atIndex);
			const hiddenUsername = this.hideCharacters(username);
			const domain = email.substring(atIndex);
			return `${hiddenUsername}${domain}`;
		}

		return email;
	}

	private hideCharacters(str: string): string {
		const visibleCharacters = 3;
		const hiddenCharacters = 7;
		return `${str.substring(0, visibleCharacters)}${"*".repeat(hiddenCharacters)}`;
	}
}
